import { ChangeDetectionStrategy, HostListener, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { LancamentoCCPopupComponent } from '../lancamento-cc-popup/lancamento-cc-popup.component';
import { LancamentoReferPopupComponent } from '../lancamento-refer-popup/lancamento-refer-popup.component';
import { FatDoctoI } from '../../../../../shared/interfaces/fat-docto-i';
import { FatDoctoIDI } from '../../../../../shared/interfaces/fat-docto-i-di';
import { FatDoctoIDIService } from '../../../../../shared/services/fat-docto-i-di.service';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { CLOSING } from 'ws';
import { LancamentoItemDIPopupComponent } from '../lancamento-item-di-popup/lancamento-item-di-popup.component';
import { LayoutService } from 'app/shared/services/layout.service';

@Component({
  selector: 'app-lancamento-item-di-list',
  templateUrl: './lancamento-item-di-list.component.html',
  styleUrls: ['./lancamento-item-di-list.component.scss'],
})
export class LancamentoItemDIListComponent implements OnInit, OnDestroy {
  public doctoIForm: FormGroup;
  dis: FatDoctoIDI[];

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  pageObject$: BehaviorSubject<PageResult<FatDoctoIDI>> = new BehaviorSubject<PageResult<FatDoctoIDI>>(null);
  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';
  view = 'module';
  page = 1;
  length = 0;
  pageSize = 5;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  public searchInput = '';
  searchEntry$: Subject<string> = new Subject<string>();
  item: FatDoctoI;
  public layoutConf: any;


  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoItemDIListComponent>,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private fatDoctoIDIService: FatDoctoIDIService,
    private layout: LayoutService
  ) {
  }

  ngOnInit() {
    console.log('this.data.payload', this.data.payload);
    this.layoutConf = this.layout.layoutConf;
    this.item = this.data.payload
    this.view = 'list';

    this.pageSize = 5
    console.log(`this.pageSize :${this.pageSize}`);



    // inicializa paginator com valores retoRnados pela API.
    this.pageObject$.subscribe(
      page => {
        if (page != null) {
          this.length = page.totalElements;
          this.pageSize = page.size;
          this.page = page.number;
          console.log(`this.pageSize :${this.pageSize}`);
          console.log(`this.page :${this.page}`);
        } else {
        }
      });
    // retorna primeira página da pesquisa.
    this.getPage(1, this.pageSize);

    this.debounceTimeSearch();
  }

  /**
  * Retorna a página requerida,
  * @param page numero da página requisitada, primeira página é 1
  * @param pageSize quantidade de itens a serem retornados
  */
  getPage(page: number, pageSize: number) {
    this.fatDoctoIDIService.getFatDoctoIDIPage(this.item.uuid, page, pageSize, this.selectedOrdem
      , this.selectedDirect).subscribe(val => this.pageObject$.next(val));
  }

  /**
  * Retorna a página da pesquisa,
  * @param search valor a ser pesquisada
  * @param page numero da página requisitada, primeira página é 1
  * @param pageSize quantidade de itens a serem retornados
  */
  getSearchPage(search: string, page: number, pageSize: number) {
    if (page === 1) {
      this.paginator.firstPage();
    }
    if (search === null || search === undefined || search.length === 0) {
      this.getPage(1, this.pageSize);
    } else {
      //TODO implementar o search no backend
      //this.fatDoctoIDIService.getFatDoctoIDIPageSearch(this.item.uuid, page, pageSize, search, this.selectedOrdem
        //, this.selectedDirect).subscribe(val => this.pageObject$.next(val));
    }
  }


  /**
   *
   * @param event Captura evento de mudança em alguma configuração no paginator e recarrega a lista.
   */
  setPageSizeOptions(event: PageEvent) {
    this.pageSize = event.pageSize;
    if (this.searchInput.length > 0) {
      this.getSearchPage(this.searchInput, event.pageIndex + 1, event.pageSize);
    } else {
      this.getPage(event.pageIndex + 1, event.pageSize);
    }
  }

  searchBy_UsingDebounce(searchString: any) {
    this.searchInput = searchString;
    this.searchEntry$.next(this.searchInput);
  }

  debounceTimeSearch() {
    this.searchEntry$
      .pipe(debounceTime(500))
      .subscribe((s) => this.getSearchPage(s, 1, this.pageSize));
  }

  private viewSize() {
    if (this.view === 'comfy') {
      return 20;
    } else if (this.view === 'module') {
      return 30;
    }
    return 100;
  }

  ngOnDestroy() {
  }

  createFatDoctoIDI(item: FatDoctoI) {
    this.fatDoctoIDIService.create(item?.uuid).subscribe(ref => {
      ref.uuid = '';
      ref.fatDoctoI = item;
      console.log('ref', ref);
      this.editDoctoIDI(ref, item);
    }, err => {
      this.confirmService.confirm(
        {
          title: `A T E N Ç Ã O !`,
          message: `Não foi Possível criar declaração de importação!\n ` + err,
          error: true
        }
      );
    })
  }

  private editDoctoIDI(ref: FatDoctoIDI, item: FatDoctoI) {
    ref.transientFatDoctoIUuid = item.uuid;
   
    let title = `DI PRODUTO: ${item?.id?.fatProduto?.codigo.toString().padStart(9, '0')} - ${item?.id?.fatProduto?.descricao}`;
    let dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoItemDIPopupComponent, {
      width: '64vw',
      maxWidth: '900px',
      disableClose: true,
      data: { title: title, payload: ref }

    });
    dialogRef.afterClosed()
      .subscribe(res => {
        this.getPage(1, this.pageSize);
        if (!res) {
          return;
        }
      });
  }

  delete(ref: FatDoctoIDI) {
    this.confirmService.confirm({ message: `Deseja realmente excluir  [${ref?.id}]?` })
      .subscribe(res => {
        if (res) {
          this.fatDoctoIDIService.deleteFatDoctoIDI(ref?.id).subscribe(s => {
            this.confirmService.confirm(
              {
                title: `S U C E S S O  !`,
                message: `Declaração de importação excluído com Sucesso !`,
                error: false
              }
            );
            this.getPage(1, this.pageSize);
          },
            (err) => {
              this.confirmService.confirm(
                {
                  title: `A T E N Ç Ã O !`,
                  message: `${err?.error.erro ?? 'Erro ao excluir declaração de importação'}`,
                  error: true
                }
              );
            });
        }
      });
  }

  


  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      });
  }

}
